import React from 'react';
import Hero from '../components/Hero';
import ClassForm from '../components/ClassForm';

export default function HomePage() {
  return (
    <main>
      <Hero />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <ClassForm />
      </div>
    </main>
  );
}